import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { userAction, profileAction } from "@redux/modules";

// Toastify
import showMessage from "@components/ShowMessage";
import showErrMessage from "@components/ShowErrMessage";

// Form Validations
import { Formik } from 'formik';
import * as yup from 'yup';

import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import "./style.scss";

//react-icons
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const AccountInfo = () => {
  const dispatch = useDispatch();
  const profileDetail = useSelector((store) => store.profile.profileDetail);
  const [passwordType, setPasswordType] = useState("password");
  const [confirmPasswordType, setConfirmPasswordType] = useState("password");
  const [show2FAModal, setShow2FAModal] = useState(false);
  const [newFAStatus, setNewFAStatus] = useState(
    profileDetail?.isOpenTwoFactor || false
  );
  const [newFAStatusForFirm, setNewFAStatusForFirm] = useState(
    profileDetail?.isOpenTwoFactorForFirm || false
  );

  useEffect(() => {
    setNewFAStatus(profileDetail?.isOpenTwoFactor || false);
  }, [profileDetail?.isOpenTwoFactor]);

  useEffect(() => {
    setNewFAStatusForFirm(profileDetail?.isOpenTwoFactorForFirm || false);
  }, [profileDetail?.isOpenTwoFactorForFirm]);

  const handlePasswordTypeChange = () => {
    setPasswordType(passwordType === "password" ? "text" : "password");
  };

  const handleConfirmPasswordTypeChange = () => {
    setConfirmPasswordType(
      confirmPasswordType === "password" ? "text" : "password"
    );
  };

  const handleChangePassword = (values, { resetForm }) => {

    if (
      values?.newPassword?.length > 0 &&
      values?.newPasswordConfirm?.length > 0
    ) {
      dispatch(
        profileAction.profileChangePassword(
          values.newPassword,
          values.newPasswordConfirm,
          values.changePassType
        )
      )
        .then((e) => {
          showMessage("Şifre Değiştirildi!");
          resetForm();
        })
        .catch((err) => {
          if (err.isHttpError) {
            if (err.error?.response?.data?.message) {
              const errorMessage = err.error.response.data.message;
              showErrMessage(errorMessage);
            } else if (err.error?.response?.data?.errors?.[0]?.message) {
              const errorMessage = err.error.response.data.errors[0].message;
              showErrMessage(errorMessage);
            } else {
              showErrMessage("Bir hata oluştu");
            }
          }
        });
    }
  };

  const handle2FAToggleClick = (checked) => {
    setShow2FAModal(true);
  };

  const confirmToggle2FA = () => {
    dispatch(profileAction.post2FAControl(newFAStatus))
      .then(() => {
        showMessage(`2FA ${newFAStatus ? "Aktif" : "Pasif"} edildi!`);
        setShow2FAModal(false);
      })
      .catch((err) => {
        if (err.isHttpError) {
          if (err.error?.response?.data?.message) {
            const errorMessage = err.error.response.data.message;
            showErrMessage(errorMessage);
          } else if (err.error?.response?.data?.errors?.[0]?.message) {
            const errorMessage = err.error.response.data.errors[0].message;
            showErrMessage(errorMessage);
          } else {
            showErrMessage("Bir hata oluştu");
          }
        }
        setShow2FAModal(false);
      });
  };

  const handle2FAToggle = () => {
    const newStatus = !newFAStatus;

    dispatch(profileAction.post2FAControl(newStatus))
      .then(() => {
        showMessage(
          newStatus
            ? "2FA başarıyla aktifleştirildi."
            : "2FA başarıyla pasifleştirildi."
        );
        setNewFAStatus(newStatus);
        setShow2FAModal(false);
      })
      .catch((err) => {
        if (err.isHttpError) {
          if (err.error?.response?.data?.message) {
            const errorMessage = err.error.response.data.message;
            showErrMessage(errorMessage);
          } else if (err.error?.response?.data?.errors?.[0]?.message) {
            const errorMessage = err.error.response.data.errors[0].message;
            showErrMessage(errorMessage);
          } else {
            showErrMessage("Bir hata oluştu");
          }
        }
        setShow2FAModal(false);
      });
  };

  const schema = yup.object({
    newPassword: yup
      .string()
      .required("Lütfen Şifrenizi Giriniz!")
      .matches(
        // Büyük/küçük harf, rakam ve en az bir özel karakter (boşluk hariç tüm özel karakterler).
        "^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=\\S+$).{8,}$",
        "Şifreniz 8 Karakter, Bir Büyük Harf, Bir Küçük Harf, Bir Rakam ve Bir Özel Karakter İçermelidir!"
      ),
    newPasswordConfirm: yup
      .string()
      .required("Lütfen Şifre Tekrarı Giriniz!")
      .oneOf([yup.ref("newPassword"), null], "Şifreler Eşleşmiyor!"),
    changePassType: yup
      .string()
      .required("Lütfen Şifre Değiştirme Süresi Seçiniz!"),
  });

  return (
    <React.Fragment>
      <h2 className="mb-sm-6 mb-4">Hesap Bilgilerim</h2>
      <p className="mb-sm-5 mb-4 fw-light">
        Aşağıdaki bilgilerde değişiklik yapabilmek için <a href="tel:08503351358" className="text-blue">0850 335 1358</a> numaralı{" "}
        <span className="text-blue">Connection Çağrı Merkezi'mizi</span> arayabilir, Satış Belgesi numaranızı ve bayi kodunuzu
        kullanarak müşteri temsilcimizle görüşebilirsiniz. Şifre değiştirme
        bölümü aracılığıyla şifrenizi değiştirebilirsiniz.
      </p>
      <div className="row gy-5 row-cols-md-3 row-cols-2 pb-sm-5 pb-4 border-bottom mb-sm-5 mb-4">
        {profileDetail && (
          <>
            {profileDetail.dealerSignName && (
              <div className="col">
                <h6 className="opacity-50">Üye tabela adı</h6>
                <p className="mb-0">{profileDetail.dealerSignName}</p>
              </div>
            )}
            {profileDetail?.employeeDTO?.name && (
              <div className="col">
                <h6 className="opacity-50">Üye Adı</h6>
                <p className="mb-0">{profileDetail.employeeDTO.name}</p>
              </div>
            )}
            {profileDetail?.employeeDTO.surname && (
              <div className="col">
                <h6 className="opacity-50">Üye Soyadı</h6>
                <p className="mb-0">{profileDetail.employeeDTO.surname}</p>
              </div>
            )}
            {profileDetail.salesDocumentNumber && (
              <div className="col">
                <h6 className="opacity-50">Satış Belgesi Numarası</h6>
                <p className="mb-0">{profileDetail.salesDocumentNumbe}</p>
              </div>
            )}
            {profileDetail.uniqueField && (
              <div className="col">
                <h6 className="opacity-50">Erc Kodu</h6>
                <p className="mb-0">{profileDetail.uniqueField}</p>
              </div>
            )}
            {profileDetail.employeeDTO.mobileNo && (
              <div className="col">
                <h6 className="opacity-50">Cep Telefonu</h6>
                <p className="mb-0">{profileDetail.employeeDTO.mobileNo}</p>
              </div>
            )}
          </>
        )}
      </div>

      {newFAStatusForFirm && (
        <div className="row gy-5 row-cols-md-3 row-cols-2 pb-sm-5 pb-2 border-bottom mb-sm-5 mb-2">
          <div className="col">
            <h5 className="text-blue mb-sm-5 mb-4">
              İki Faktörlü Kimlik Doğrulama
            </h5>
            <div className="custom-switch-container d-flex align-items-center mt-1">
              <label htmlFor="2fa-switch" className="mx-2">
                <span className="fw-bold">Pasif</span>
              </label>
              <div className="custom-switch">
                <input
                  type="checkbox"
                  id="2fa-switch"
                  checked={newFAStatus}
                  onChange={(e) => handle2FAToggleClick(e.target.checked)}
                />
                <label htmlFor="2fa-switch"></label>
              </div>
              <label htmlFor="2fa-switch" className="mx-2">
                <span className="fw-bold">Aktif</span>
              </label>
            </div>
          </div>
        </div>
      )}

      {/* 2FA Confirmation Modal */}
      <Modal show={show2FAModal} onHide={() => setShow2FAModal(false)} centered>
        <Modal.Header>
          <Modal.Title>Durumu Değiştirme</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {newFAStatus ? (
            <>
              İki faktörlü kimlik doğrulamayı (2FA) <b>pasif</b> etmek
              istediğinizden emin misiniz?
              <br />
              2FA pasif edildiğinde hesabınız için güvenlik seviyesi düşecektir.
            </>
          ) : (
            <>
              İki faktörlü kimlik doğrulamayı (2FA) <b>aktif</b> etmek
              istediğinizden emin misiniz?
              <br />
              2FA aktif edildiğinde hesabınızın güvenliği artacaktır.
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn btn-outline-secondary"
            onClick={() => setShow2FAModal(false)}
          >
            İptal
          </Button>
          <Button
            className={`btn ${
              newFAStatus ? "btn-danger-passive" : "btn-success-active"
            }`}
            onClick={handle2FAToggle}
          >
            {newFAStatus ? "Pasif Et" : "Aktif Et"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Formik
        validationSchema={schema}
        onSubmit={(values, { resetForm }) =>
          handleChangePassword(values, { resetForm })
        }
        initialValues={{
          newPassword: "",
          newPasswordConfirm: "",
          changePassType: "",
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <Form
            className="form-change-password"
            noValidate
            onSubmit={handleSubmit}
          >
            <Form.Group>
              <h5 className="text-blue mb-0">Şifre Değiştirme</h5>
              <div className="row gy-0 row-cols-md-3 row-cols-1 align-items-start">
                <div className="col position-relative">
                  <Form.Label htmlFor="newPasswordInput" className="mb-1">Yeni Şifre</Form.Label>

                  <div className="position-relative">
                    <Form.Control
                      className="form-control"
                      autoComplete="chrome-off"
                      type={passwordType}
                      placeholder="Yeni Şifre"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="newPassword"
                      id="newPasswordInput"
                      value={values.newPassword}
                      isInvalid={
                        !!errors.newPassword &&
                        touched.newPassword &&
                        !!errors.newPassword
                      }
                    />
                    {values.newPassword?.length > 0 && (
                      <>
                        {passwordType === "password" ? (
                          <FaEyeSlash
                            onClick={handlePasswordTypeChange}
                            className="password-eye"
                          />
                        ) : (
                          <FaEye
                            onClick={handlePasswordTypeChange}
                            className="password-eye"
                          />
                        )}
                      </>
                    )}
                    <Form.Control.Feedback className="FeedBack" type="invalid">
                      {errors.newPassword &&
                        touched.newPassword &&
                        errors.newPassword}
                    </Form.Control.Feedback>
                  </div>
                </div>

                <div className="col position-relative">
                  <Form.Label htmlFor="newPasswordConfirmInput" className="mb-1">
                    Yeni Şifre Tekrar
                  </Form.Label>

                  <div className="position-relative">
                    <Form.Control
                      className="form-control"
                      autoComplete="chrome-off"
                      type={confirmPasswordType}
                      placeholder="Yeni Şifre Tekrar"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="newPasswordConfirm"
                      id="newPasswordConfirmInput"
                      value={values.newPasswordConfirm}
                      isInvalid={
                        !!errors.newPasswordConfirm &&
                        touched.newPasswordConfirm &&
                        !!errors.newPasswordConfirm
                      }
                    />

                    {values.newPasswordConfirm?.length > 0 && (
                      <>
                        {confirmPasswordType === "password" ? (
                          <FaEyeSlash
                            onClick={handleConfirmPasswordTypeChange}
                            className="password-eye"
                          />
                        ) : (
                          <FaEye
                            onClick={handleConfirmPasswordTypeChange}
                            className="password-eye"
                          />
                        )}
                      </>
                    )}

                    <Form.Control.Feedback className="FeedBack" type="invalid">
                      {errors.newPasswordConfirm &&
                        touched.newPasswordConfirm &&
                        errors.newPasswordConfirm}
                    </Form.Control.Feedback>
                  </div>
                </div>

                <div className="col">
                  <Form.Label htmlFor="changePassTypeSelect" className="mb-1">
                    Şifre Değiştirme Süresi
                  </Form.Label>
                  <Form.Control
                    as="select"
                    className="form-control"
                    autoComplete="chrome-off"
                    type={passwordType}
                    placeholder="Yeni Şifre Tekrar"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    name="changePassType"
                    id="changePassTypeSelect"
                    value={values.changePassType}
                    isInvalid={
                      !!errors.changePassType &&
                      touched.changePassType &&
                      !!errors.changePassType
                    }
                  >
                    <option>Şifre Değiştirme Süresi Seçiniz</option>
                    <option value="ONE">1 Ay</option>
                    <option value="THREE">3 Ay</option>
                    <option value="SIX">6 Ay</option>
                  </Form.Control>

                  <Form.Control.Feedback className="FeedBack" type="invalid">
                    {errors.changePassType &&
                      touched.changePassType &&
                      errors.changePassType}
                  </Form.Control.Feedback>
                </div>

                <div className="col">
                  <button
                    type="submit"
                    className="btn btn-blue py-sm-3 py-2 px-sm-4 px-3 w-100 mt-3"
                  >
                    Değiştir
                  </button>
                </div>
              </div>
            </Form.Group>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
};

export default AccountInfo;
